import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { inspectionService } from '../services/inspection.service';
import type { InspectionVerification } from '../types/inspection.types';
import { INSPECTION_QUERY_KEY } from './useVerificationsForInspection';

export function useApproveVerification(): {
  approveVerification: UseMutateFunction<InspectionVerification, Error, string>;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (verificationId: string) => inspectionService.approveVerification(verificationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: INSPECTION_QUERY_KEY });
    },
  });

  return {
    approveVerification: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
  };
}
